<template>
  <div v-show="menuActive" class="action-menu">
    <div class="menu-backdrop" @click="closeMenu"></div>
    <div class="menu" ref="menu" @click="closeMenu">
      <template v-if="!!lists.length">
        <div class="heading">Listy:</div>
        <button v-for="list in lists" :key="list._id" @click="moveTo(list)">
          <div class="icon md-icon">format_list_bulleted</div>
          <span>{{ list.name }}</span>
        </button>
        <div class="separator" />
      </template>
      <button @click="moveTo(notepad)">
        <div class="icon md-icon">border_color</div>
        <span>{{ notepad.name }}</span>
      </button>
      <button v-if="settings.showOrphans" @click="moveTo(unlist)">
        <span>{{ unlist.name }}</span>
      </button>
    </div>
  </div>
</template>

<style scoped>
.heading {
  padding: var(--basic-padding);
}
.menu-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  background: var(--bg-color-hover);
}
.menu {
  z-index: 15;
  position: fixed;
  border-radius: var(--rounding-smaller);
  background-color: var(--bg-color-card-default);
  border: var(--menu-border);
  display: flex;
  flex-flow: column nowrap;
  max-height: 90vh;
  overflow-y: auto;
}
.icon {
  flex: var(--indent-size) 0 0;
  margin: 0;
}
button {
  min-height: var(--indent-size);
  min-width: 150px;
  display: flex;
  align-items: center;
  border: none;
  background-color: transparent;
  cursor: pointer;
}
button:hover {
  background: var(--bg-color-hover);
}
.menu span {
  text-align: left;
}

.separator {
  width: 100%;
  margin: 4px 0;
  border-top: 1px solid grey;
}
</style>

<script>
import { getItem } from "@/reactive-cache";
import { Item } from "../item";
import selection from "../selection";
import { appendItem } from "@/ordered-relation";
import { defaultListID } from "../structure";
import settings from "@/synced-settings";

export default {
  data() {
    return {
      menuActive: false,
      triggerEl: null,
      item: new Item({}, this.$reactiveCache, this.$defaultDB),
      settings: settings,
    };
  },
  computed: {
    lists() {
      return getItem("root:list").getChildren();
    },
    notepad() {
      return getItem("notepad");
    },
    unlist() {
      return getItem(defaultListID);
    },
  },
  methods: {
    moveTo(list) {
      if (selection.length) {
        selection.appendTo(list);
      } else {
        appendItem(list, this.item).save();
      }
    },
    openMenu() {
      this.menuActive = true;
      this.$nextTick(() => {
        // we need the size for calculations, so it has to render first
        this.setMenuPosition(this.$refs.menu);
      });
    },
    setMenuPosition(menu) {
      const viewport = document.getElementById("toplevel").getBoundingClientRect();

      const width = menu.offsetWidth;
      if (viewport.width > this.triggerEl.left + width) {
        menu.style.left = this.triggerEl.left + "px";
        menu.style.right = "auto";
      } else if (this.triggerEl.right > width) {
        menu.style.right = viewport.width - this.triggerEl.right + "px";
        menu.style.left = "auto";
      } else {
        menu.style.left = "5vw";
        menu.style.right = "auto";
      }

      const height = menu.offsetHeight;
      if (viewport.height > this.triggerEl.top + height) {
        menu.style.top = this.triggerEl.top + "px";
        menu.style.bottom = "auto";
      } else if (this.triggerEl.bottom > height) {
        menu.style.bottom = viewport.height - this.triggerEl.bottom + "px";
        menu.style.top = "auto";
      } else {
        menu.style.bottom = "5vh";
        menu.style.top = "auto";
      }
    },
    closeMenu() {
      this.menuActive = false;
    },
  },
  mounted() {
    this.$root.$on("list-menu", (data) => {
      this.triggerEl = data.button;
      this.item = data.item;
      this.openMenu();
    });
  },
};
</script>
